import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useAppDispatch, useAppStore } from "@/global/store";
import {
  gameFiltersState,
  selectSections,
} from "@/global/store/data/gameFilters";
import React from "react";
import { findMappedSection } from "./utils.seatMap";
import { filterPanelNames } from "@/global/config/constants";
import { useFilterPanelsState } from "../GameFilters/useFilterPanels";

export function useSeatMap2d() {
  const dispatch = useAppDispatch();
  const teamConfig = useTeamConfig();
  const availableSections = useAppStore(selectSections);
  const [viewer, setViewerInstance] = React.useState<any>(null);
  const { set: setFilterPanelsState } = useFilterPanelsState();

  const setViewerAvailability = () => {
    if (!viewer || !availableSections?.length) return;

    const sectionIds = availableSections?.map((apiSection) => {
      const sectionName = findMappedSection(teamConfig, apiSection);
      let sectionId = "S_" + sectionName?.mapSectionName;
      return sectionId;
    });

    if (!sectionIds?.length) return;
    viewer?.setAvailability("section", sectionIds);
  };

  const setSelectedSection = (node: any) => {
    if (!node || !node?.id) return;

    let apiSectionName = null;
    availableSections?.forEach((apiSection) => {
      let sectionId = node?.id?.replace("S_", "");
      const mappedSection = findMappedSection(teamConfig, apiSection);
      if (mappedSection?.mapSectionName == sectionId) {
        apiSectionName = mappedSection;
      }
    });
    if (!apiSectionName) return;

    dispatch(gameFiltersState.actions.updateSectionSelected(apiSectionName));
    setFilterPanelsState({
      lastChangedFilter: filterPanelNames.section_selector,
    });
  };

  const resetSelectedSection = () => {
    let selectedNodes = viewer?.getNodesByTag("section", "selected");
    viewer?.setNodesTag(selectedNodes, null);

    dispatch(gameFiltersState.actions.updateSectionSelected(null));
    setFilterPanelsState({
      lastChangedFilter: filterPanelNames.section_selector,
    });
  };

  return {
    viewer,
    setViewerInstance,
    setViewerAvailability,
    setSelectedSection,
    resetSelectedSection,
  };
}
